import angular from 'angular';
import referralKiwiSelect from './referralKiwiSelect';
import './style.scss';

export default angular
  .module('components.referralKiwiSelect', [])
  .component('referralKiwiSelect', referralKiwiSelect).name;
